// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {CharacterRect} from '../search-index/character-rect.js'

export class PDFPageRecognizedText {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): PDFPageRecognizedText {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPDFPageRecognizedText(
    bb: flatbuffers.ByteBuffer,
    obj?: PDFPageRecognizedText
  ): PDFPageRecognizedText {
    return (obj || new PDFPageRecognizedText()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPDFPageRecognizedText(
    bb: flatbuffers.ByteBuffer,
    obj?: PDFPageRecognizedText
  ): PDFPageRecognizedText {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new PDFPageRecognizedText()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  pageIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0
  }

  text(): string | null
  text(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  text(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  characterRects(index: number, obj?: CharacterRect): CharacterRect | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset
      ? (obj || new CharacterRect()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!)
      : null
  }

  characterRectsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startPDFPageRecognizedText(builder: flatbuffers.Builder) {
    builder.startObject(3)
  }

  static addPageIndex(builder: flatbuffers.Builder, pageIndex: number) {
    builder.addFieldInt32(0, pageIndex, 0)
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, textOffset, 0)
  }

  static addCharacterRects(builder: flatbuffers.Builder, characterRectsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, characterRectsOffset, 0)
  }

  static startCharacterRectsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 2)
  }

  static endPDFPageRecognizedText(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 6) // text
    builder.requiredField(offset, 8) // character_rects
    return offset
  }

  static createPDFPageRecognizedText(
    builder: flatbuffers.Builder,
    pageIndex: number,
    textOffset: flatbuffers.Offset,
    characterRectsOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    PDFPageRecognizedText.startPDFPageRecognizedText(builder)
    PDFPageRecognizedText.addPageIndex(builder, pageIndex)
    PDFPageRecognizedText.addText(builder, textOffset)
    PDFPageRecognizedText.addCharacterRects(builder, characterRectsOffset)
    return PDFPageRecognizedText.endPDFPageRecognizedText(builder)
  }
}
